export default __webpack_public_path__ + "static/media/p2023-6.fab4c955.jpeg";